// Employee error feedback page (/error-reports) and its dialogs.
// Stored statuses (Beklemede, İşlemde, Tamamlandı, İptal) stay Turkish; the
// Excel file keeps its old layout.
const errorReports = {
  page: {
    title: 'Employee Error Feedback',
    subtitle: 'Reports employees send from Profile › Report a Bug. Update their status to keep track.',
  },
  actions: {
    excel: 'Download Table',
    excelHint: 'Download the reports in the list as Excel',
  },
  stats: {
    total: 'Total Reports',
    totalShort: 'Total',
    pending: 'Pending',
    pendingShort: 'Pending',
    screenshots: 'With Screenshot',
    screenshotsShort: 'Screenshot',
    recent: 'Last 24 Hours',
    recentShort: '24 hours',
    share: '{{percent}}% of all reports',
  },
  toolbar: {
    search: 'Search description, name or ID…',
    searchShort: 'Search reports…',
    status: 'Report status',
    screenshots: 'With screenshot',
    screenshotsHint: 'Only reports with a screenshot',
    recent: 'Last 24 hours',
    recentHint: 'Only reports from the last 24 hours',
    newest: 'Newest first',
    oldest: 'Oldest first',
    sortHint: 'Change the date order',
  },
  status: {
    all: 'All',
    pending: 'Pending',
    inProgress: 'In progress',
    completed: 'Completed',
    cancelled: 'Cancelled',
  },
  columns: {
    errorSummary: 'Error Description',
    status: 'Status',
    userName: 'User Name',
    timestamp: 'Date',
    screenshotUrl: 'Screenshot',
    uid: 'User ID',
    deviceInfo: 'Device',
    browserInfo: 'Browser',
    errorDetails: 'Error Details',
  },
  table: {
    listLabel: 'Error reports',
    empty: 'No error reports match the filters',
    rangeOf: 'of {{total}} reports',
    ofTotal: 'out of {{total}} reports',
    jump: 'Go to page',
    noSummary: 'No description',
    view: 'View',
    none: 'None',
    changeStatus: 'Change status',
    updatedBy: 'Updated by {{name}} · {{date}}',
  },
  panel: {
    label: 'Selected report',
    heading: 'Error report',
    screenshot: 'Screenshot',
    details: 'All Details',
    statusTitle: 'Status',
    updatedBy: 'Updated by {{name}} · {{date}}',
    notUpdated: 'The status has not been updated yet',
    summary: 'Error description',
    screenshotHint: 'Click to enlarge',
    withScreenshot: 'With screenshot',
    markDone: 'Mark as Completed',
    reopen: 'Reopen (Pending)',
    reopenHint: 'Sets the report back to "Pending"',
    user: 'User',
    userId: 'User ID',
    date: 'Date',
    device: 'Device',
    browser: 'Browser',
    updater: 'Status updated by',
    updatedAt: 'Updated on',
  },
  details: {
    title: 'Error Details',
    summary: 'Error Description',
    user: 'User',
    name: 'Name',
    id: 'ID',
    date: 'Date',
    status: 'Status',
    updatedBy: 'Updated by',
    updatedAt: 'Updated on',
    system: 'System',
    device: 'Device',
    browser: 'Browser',
    detailed: 'Detailed error information',
    noInfo: 'No information',
    screenshot: 'Screenshot',
    close: 'Close',
  },
  screenshot: {
    title: 'Screenshot',
    alt: 'Screenshot attached to the error report',
    missing: 'No screenshot found.',
    openInTab: 'Open in new tab',
    close: 'Close',
  },
  toast: {
    loadError: 'The error reports could not be loaded',
    notSignedIn: 'You are not signed in',
    statusUpdated: 'Status updated',
    statusError: 'The status could not be updated',
    excelDone: 'Error reports downloaded',
    excelError: 'The file could not be downloaded',
    pageJumpInvalid: 'Please enter a page number between 1 and {{max}}.',
  },
};

export default errorReports;
